import React from "react";

export default () => {
  return (
    <div className="flex justify-center mb-6">
        Could not find a link page
    </div>
  );
}
